import React from 'react';
import { Card as BSCard } from 'react-bootstrap';
import cn from 'classnames';

const Card = React.forwardRef((props, ref) => {
  const { children, className, ...rest } = props;

  const classes = cn('shadow-sm rounded px-3 pt-3 pb-4', className);

  return (
    <BSCard ref={ref} border="light" variant="light" className={classes} {...rest}>
      {children}
    </BSCard>
  );
});

const Header = (props) => {
  const { children, className, ...rest } = props;

  const classes = cn(
    'p-0 mb-3 border-bottom-0 bg-white rounded-top text-gray-800',
    className
  );

  return (
    <BSCard.Header className={classes} as="h6" {...rest}>
      {children}
    </BSCard.Header>
  );
};

const Body = (props) => {
  const { children, className, ...rest } = props;

  const classes = cn('p-0', className);

  return (
    <BSCard.Body className={classes} {...rest}>
      {children}
    </BSCard.Body>
  );
};

Card.Header = Header;
Card.Body = Body;
Card.Title = BSCard.Title;
Card.Footer = BSCard.Footer;
Card.Img = BSCard.Img;
Card.ImgOverlay = BSCard.ImgOverlay;
Card.Link = BSCard.Link;
Card.Subtitle = BSCard.Subtitle;
Card.Text = BSCard.Text;

export default Card;
